// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xUserSetupType = Readonly<{
    phone?: string;
    phoneErrorMessage?: string;
}>;

export const initialPhoneNumberState: xUserSetupType = {
    phone: "",
    phoneErrorMessage: "",
};

const reducer = {
    "xUserSetup/SetPhoneNumber": (
        draft: Draft<xUserSetupType>,
        action: { phone?: string; phoneErrorMessage?: string },
    ) => {
        if (typeof action.phone !== "undefined") {
            draft.phone = action.phone;
            draft.phoneErrorMessage = action.phoneErrorMessage;
        }
    },
};

const xUserSetup = createTypedReducerWithImmer(initialPhoneNumberState, reducer);

(reducers as any).xUserSetup = xUserSetup;

export type xUserSetupState = {
    xUserSetup: xUserSetupType;
} & ApplicationState;
